import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

export const Sukses = () => {
  const [searchParams] = useSearchParams();
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(""); // Untuk menampilkan pesan terkait status
  const navigate = useNavigate();

  const orderId = searchParams.get("order_id");
  const status = searchParams.get("transaction_status");

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        // Periksa orderId apakah sudah ada
        if (orderId) {
          const res = await axios.get(
            `https://cakrawalajakarta-server.onrender.com/api/payment/status/${orderId}`
          );
          if (res.data) {
            setTransaction(res.data);
          } else {
            console.error("Data transaksi tidak ditemukan.");
          }
        }
      } catch (error) {
        console.error("Gagal mengambil data transaksi:", error.message);
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchTransaction();
    }

    // Update status berdasarkan status dari query params
    if (status === "settlement") {
      setMessage("Pembayaran berhasil!");
    } else if (status === "pending") {
      setMessage("Pembayaran Anda sedang diproses, harap tunggu konfirmasi.");
    } else if (status === "failed") {
      setMessage("Pembayaran gagal. Silakan coba lagi.");
    }
  }, [orderId, status]);

  return (
    <section
      id="sukses-section"
      className="w-full min-h-screen flex justify-center items-center relative bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://images.pexels.com/photos/325185/pexels-photo-325185.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Overlay Transparan */}
      <div className="absolute inset-0 bg-cyan-900 bg-opacity-40 backdrop-blur-sm"></div>

      {/* Konten */}
      <div className="relative z-10 flex flex-col items-center text-white w-full px-4 md:px-8">
        <fieldset className="fieldset w-full sm:w-96 bg-white bg-opacity-40 p-6 rounded-xl shadow-lg backdrop-blur-md">
          <p className="text-2xl font-semibold mb-4 text-center">Pembayaran</p>

          {loading ? (
            <p className="text-center">Mengambil data transaksi...</p>
          ) : transaction ? (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <p className="mb-2 text-center">Order ID: {transaction.order_id}</p>
              <p className="mb-2 text-center">Status: {transaction.transaction_status}</p>
              <p className="mb-2 text-center">
                Total: Rp {Number(transaction.gross_amount).toLocaleString()}
              </p>

              <button
                onClick={() => navigate("/")}
                className="w-full bg-emerald-600 py-3 mt-4 rounded-xl hover:bg-emerald-700"
              >
                Kembali ke Beranda
              </button>
            </motion.div>
          ) : (
            <p className="text-red-500 text-center">Data transaksi tidak ditemukan.</p>
          )}

          {/* Menampilkan pesan status */}
          <p className="text-center mt-4">{message}</p>
        </fieldset>
      </div>
    </section>
  );
};

